import { AppBrandMark } from './app-brand-mark';

interface AppBrandProps {
  label?: string;
  labelClassName?: string;
  iconSize?: number;
  markClassName?: string;
  showLabel?: boolean;
  className?: string;
}

export function AppBrand({
  label = 'Link Park',
  labelClassName = 'text-lg font-semibold text-foreground',
  iconSize = 20,
  markClassName = 'size-9 rounded-lg',
  showLabel = true,
  className,
}: AppBrandProps) {
  return (
    <div className={`flex min-w-0 items-center gap-2 ${className ?? ''}`.trim()}>
      <AppBrandMark iconSize={iconSize} className={`shrink-0 ${markClassName}`.trim()} />
      {showLabel ? <span className={`truncate ${labelClassName}`.trim()}>{label}</span> : null}
    </div>
  );
}
